import { cfAPI } from "../api";
import { createRequestHandler } from "../utils/requestHandlers"; // Import the new handler

// Action Types
const MEDIA_REQUEST = "MEDIA_REQUEST";
const MEDIA_ERROR = "MEDIA_ERROR";
const DELETE_IMAGE = "DELETE_IMAGE";

const BaseRoute = "mediaapi/api/v1/media/byName";

// Reusable action types object for consistency
const actionTypes = {
  deleteImage: {
    request: MEDIA_REQUEST,
    success: DELETE_IMAGE,
    error: MEDIA_ERROR,
  },
};

const INITIAL_STATE = {
  loading: false,
  media: [],
  image: {},
  error: "",
};

export const MediaBaseRouteDelete = (name, fileName) =>
  `${BaseRoute}/${name}/${fileName}`;

// The action now uses the createRequestHandler and handles toasts
export const DeleteMedia = (name, fileName) => async (dispatch) => {
  await createRequestHandler(
    dispatch,
    () => cfAPI.delete(MediaBaseRouteDelete(name, fileName)),
    actionTypes.deleteImage,
    "Image Deleted" // The success toast message is passed here
  );
};

// The reducer is now a pure function without side effects
export const MediaReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case MEDIA_REQUEST:
      return { ...state, loading: true };
    case DELETE_IMAGE:
      return {
        ...state,
        loading: false,
      };
    case MEDIA_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    default:
      return state;
  }
};
